import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ChevronUp16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M12.7461 9.48333L12.7451 9.48228L8.57068 5.27036C8.41147 5.08109 8.20279 5 8.00036 5C7.79783 5 7.59286 5.08048 7.43474 5.24092L3.25531 9.48263C2.92808 9.81767 2.9133 10.3714 3.22314 10.7223C3.53617 11.0785 4.05942 11.0892 4.3867 10.7555L8.00031 7.08839L11.6139 10.7583C11.9419 11.0924 12.4633 11.0792 12.7773 10.7244C13.0856 10.3721 13.0725 9.81861 12.7461 9.48333Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
